import FreeHot from './freehot.vue'

export default FreeHot
